import { defaultPlayerSize } from '../tests/testContexts';
import { UseCase } from './UseCase';
export class PlayerMoveUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.player.updatePosition(event.username, event.position, defaultPlayerSize);
    }
}
